import ChatWindowHeader from './ChatWindowHeader';

export default ChatWindowHeader;
